<template>
    <NuxtLayout name="default">
        <SmuError
            data-testid="error-page"
            :title="title"
            :status-code="error.status"
            :description="errorMessage"
            :info-box-title="description"
            :info-box-description="instruction"
            :action-text="t('helpers.buttons.dashboard')"
            :action="goToDashboard"
        />
    </NuxtLayout>
</template>

<script setup lang="ts">
import type { NuxtError } from "nuxt/app";
import { SmuError } from "@smakecloud/smake-ui";

const { t } = useI18n();
const { slug } = storeToRefs(useSlugStore());

const props = defineProps<{
    error: NuxtError;
}>();

const title = computed(() => {
    if (props.error.status) {
        return t(`errors.${String(props.error.status)}.title`);
    }

    return t(`errors.unknown.title`);
});

const description = computed(() => {
    if (props.error.status) {
        return t(`errors.${String(props.error.status)}.description`);
    }

    return t(`errors.unknown.description`);
});

const instruction = computed(() => {
    if (props.error.status) {
        return t(`errors.${String(props.error.status)}.instruction`);
    }

    return t(`errors.unknown.instruction`);
});

const errorMessage = computed(() => {
    if (props.error.status) {
        return t(`errors.${String(props.error.status)}.message`);
    }

    return t(`errors.unknown.message`);
});

function goToDashboard() {
    return navigateTo({
        name: "slug-dashboard",
        params: { slug: slug.value ?? "" },
    });
}
</script>
